"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _immutable = _interopRequireDefault(require("immutable"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _colors = require("HubStyleTokens/colors");

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedList = _interopRequireDefault(require("I18n/components/FormattedList"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H7"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _UIIconCircle = _interopRequireDefault(require("UIComponents/icon/UIIconCircle"));

var _UIMediaObject = _interopRequireDefault(require("UIComponents/layout/UIMediaObject"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIDescriptionList = _interopRequireDefault(require("UIComponents/list/UIDescriptionList"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UITooltipContent = _interopRequireDefault(require("UIComponents/tooltip/UITooltipContent"));

var Tier = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/Tier"));

var _Pricing = _interopRequireDefault(require("ecosystem-marketplace-core/records/Pricing"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _tiers = require("../../../../constants/tiers");

var _auth = require("../../../../selectors/auth");

var _urls = require("../../../../utils/urls");

var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.detail.overview.sidebar.requirements." + key;
};

var flattenedTiersOrder = _tiers.ORDER.reduce(function (final, current) {
  return current instanceof _tiers.TierGroup ? final.union(current.tiers) : final.add(current);
}, _immutable.default.OrderedSet());

var getTierSortValue = function getTierSortValue(tier) {
  return flattenedTiersOrder.toList().indexOf(tier);
};

var Section = function Section(_ref) {
  var children = _ref.children,
      label = _ref.label;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement("dt", null, label), _react.default.createElement("dd", null, children));
};

var Requirements = function Requirements(_ref2) {
  var appName = _ref2.appName,
      companyName = _ref2.companyName,
      homemade = _ref2.homemade,
      hubInstallable = _ref2.hubInstallable,
      nonTrialHubInstallable = _ref2.nonTrialHubInstallable,
      onTrackInteraction = _ref2.onTrackInteraction,
      appPricingUrl = _ref2.pricingUrl,
      pricings = _ref2.pricings,
      tiers = _ref2.tiers;

  var pricingPageUrl = "/pricing/" + _PortalIdParser.default.get();

  var trackInteraction = (0, _react.useCallback)(function (action, value) {
    return onTrackInteraction(action, 'requirements', value);
  }, [onTrackInteraction]);
  var sortedTiers = (0, _react.useMemo)(function () {
    return tiers.filter(function (tier) {
      return tier !== Tier.CRM_FREE;
    }).sort(function (tierA, tierB) {
      var tierAValue = getTierSortValue(tierA);
      var tierBValue = getTierSortValue(tierB);
      if (tierAValue < tierBValue) return -1;
      if (tierAValue > tierBValue) return 1;
      return 0;
    });
  }, [tiers]);
  var renderedTierGroups = (0, _react.useMemo)(function () {
    if (tiers.includes(Tier.HUBSPOT_FREE)) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('allPlans')
      });
    }

    return _tiers.ORDER.reduce(function (final, current) {
      if (current instanceof _tiers.TierGroup) {
        var groupTiers = current.tiers.filter(function (tier) {
          return tiers.includes(tier);
        });

        if (groupTiers.isEmpty()) {
          return final;
        }

        var tier = groupTiers.first();
        var tierI18nKey = (0, _i18n.getTierI18nKey)(tier);

        var renderedTierLabel = _react.default.createElement(_FormattedMessage.default, {
          key: tier,
          message: tier === groupTiers.last() ? tierI18nKey : getI18nKey('lowestTier'),
          options: {
            tier: (0, _unescapedText.default)(tierI18nKey)
          }
        });

        final.push(renderedTierLabel);
      } else if (tiers.includes(current)) {
        final.push(_react.default.createElement(_FormattedMessage.default, {
          key: current,
          message: (0, _i18n.getTierI18nKey)(current)
        }));
      }

      return final;
    }, []);
  }, [tiers]);

  var renderTiersTooltipContent = function renderTiersTooltipContent() {
    return _react.default.createElement(_UITooltipContent.default, null, _react.default.createElement(_H.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('tiersTooltip.headingText')
    })), _react.default.createElement(_UIList.default, {
      styled: true
    }, sortedTiers.map(function (tier) {
      return _react.default.createElement(_FormattedMessage.default, {
        key: tier,
        message: (0, _i18n.getTierI18nKey)(tier)
      });
    }).toArray()), _react.default.createElement(_FormattedJSXMessage.default, {
      message: getI18nKey('tiersTooltip.learnMoreLink_jsx'),
      options: {
        external: true,
        href: pricingPageUrl,
        onClick: function onClick() {
          return trackInteraction('click tiers tooltip pricing link');
        }
      },
      elements: {
        Link: _UILink.default
      }
    }));
  };

  var renderedCompatibility = (0, _react.useMemo)(function () {
    if (hubInstallable === null) {
      return _react.default.createElement(_UILink.default, {
        external: true,
        href: "https://www.hubspot.com/pricing",
        onClick: function onClick() {
          return trackInteraction('click public pricing link');
        }
      }, _react.default.createElement(_FormattedList.default, {
        exclusive: true
      }, renderedTierGroups));
    }

    var compatibilityI18nKey;

    if (!hubInstallable) {
      compatibilityI18nKey = 'none';
    } else {
      if (!nonTrialHubInstallable) {
        compatibilityI18nKey = 'trial';
      } else {
        compatibilityI18nKey = 'plan';
      }
    }

    return _react.default.createElement(_UIMediaObject.default, {
      align: "start",
      itemLeft: _react.default.createElement(_UIIconCircle.default, {
        name: hubInstallable ? 'success' : 'remove',
        color: _colors.OLAF,
        backgroundColor: hubInstallable ? _colors.OZ : _colors.CANDY_APPLE_DARK,
        borderWidth: 0,
        padding: 0.25,
        size: 8,
        style: {
          position: 'relative',
          top: -2
        }
      }),
      spacing: "extra-small"
    }, _react.default.createElement(_FormattedJSXMessage.default, {
      message: getI18nKey("compatibility." + compatibilityI18nKey + "_jsx"),
      options: {
        external: true,
        href: pricingPageUrl,
        onClick: function onClick() {
          return trackInteraction('click account plan link');
        }
      },
      elements: {
        Link: _UILink.default
      }
    }));
  }, [hubInstallable, nonTrialHubInstallable, pricingPageUrl, renderedTierGroups, trackInteraction]);

  var renderedAppPricingPlans = _react.default.createElement(_UILink.default, {
    external: !!appPricingUrl,
    href: (0, _urls.getFormattedUrl)(appPricingUrl) || '#pricing',
    onClick: function onClick() {
      return trackInteraction('click app pricing link');
    }
  }, _react.default.createElement(_FormattedReactMessage.default, {
    message: getI18nKey('pricingPlans'),
    options: {
      count: pricings.size,
      plans: _react.default.createElement(_FormattedList.default, {
        exclusive: true
      }, pricings.map(function (pricing, index) {
        return _react.default.createElement("span", {
          key: "pricing-" + index
        }, pricing.get('name'));
      }))
    }
  }));

  return _react.default.createElement(_UIDescriptionList.default, null, !tiers.isEmpty() && _react.default.createElement(_auth.AppCompatibilityGate, null, _react.default.createElement(Section, {
    label: _react.default.createElement(_UIHelpIcon.default, {
      title: "",
      tooltipProps: {
        Content: renderTiersTooltipContent,
        maxWidth: 300,
        onOpenChange: function onOpenChange(_ref3) {
          var open = _ref3.target.value;

          if (open) {
            trackInteraction('hover subscription help icon');
          }
        },
        use: 'longform'
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('compatibilityHeadingText')
    }))
  }, renderedCompatibility)), !pricings.isEmpty() && _react.default.createElement(Section, {
    label: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('pricingPlansHeadingText'),
      options: {
        name: homemade ? appName : companyName
      }
    })
  }, renderedAppPricingPlans));
};

Requirements.propTypes = {
  appName: _propTypes.default.string.isRequired,
  companyName: _propTypes.default.string.isRequired,
  homemade: _propTypes.default.bool.isRequired,
  hubInstallable: _propTypes.default.bool,
  nonTrialHubInstallable: _propTypes.default.bool,
  onTrackInteraction: _propTypes.default.func.isRequired,
  pricingUrl: _propTypes.default.string,
  pricings: _reactImmutableProptypes.default.listOf(_propTypes.default.instanceOf(_Pricing.default)).isRequired,
  tiers: _reactImmutableProptypes.default.set.isRequired
};
var _default = Requirements;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/overview/sidebar/Requirements.js
// module id = 824
// module chunks = 209 210 211 212